(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joa-look-carousel"] && !Shopify.designMode) return;
  try {
    
  const getLookTrack = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest('[data-look-track]');
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const track = getLookTrack(event.target);
    if (!track) return;

    track.dataset.dragging = 'true';
    track.dataset.dragStartX = String(event.clientX);
    track.dataset.dragStartScroll = String(track.scrollLeft);
    track.classList.add('is-dragging');
    track.setPointerCapture(event.pointerId);
  });

  document.addEventListener('pointermove', (event) => {
    const track = getLookTrack(event.target);
    if (!track || track.dataset.dragging !== 'true' || !track.hasPointerCapture(event.pointerId)) return;
    track.scrollLeft = Number(track.dataset.dragStartScroll) - (event.clientX - Number(track.dataset.dragStartX));
  });

  const stopLookDrag = (event) => {
    const track = getLookTrack(event.target);
    if (!track || track.dataset.dragging !== 'true') return;
    if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    delete track.dataset.dragging;
    delete track.dataset.dragStartX;
    delete track.dataset.dragStartScroll;
    track.classList.remove('is-dragging');
  };

  document.addEventListener('pointerup', stopLookDrag);
  document.addEventListener('pointercancel', stopLookDrag);

  const updateLookProgress = (carousel) => {
    const track = carousel.querySelector('[data-look-track]');
    const progress = carousel.querySelector('[data-look-progress]');
    if (!track || !progress) return;

    const maxScroll = track.scrollWidth - track.clientWidth;
    const step = maxScroll > 0 ? Math.min(5, Math.max(1, Math.round((track.scrollLeft / maxScroll) * 4) + 1)) : 1;
    progress.setAttribute('aria-label', `Progression du carrousel, étape ${step} sur 5`);
    progress.querySelectorAll('.joa-look-carousel__progress-step').forEach((item, index) => {
      item.classList.toggle('is-active', index + 1 === step);
    });
  };

  document.querySelectorAll('[data-look-carousel]').forEach(updateLookProgress);
  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (track instanceof Element && track.matches('[data-look-track]')) {
      const carousel = track.closest('[data-look-carousel]');
      if (carousel) updateLookProgress(carousel);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-look-scroll]');
    if (!button) return;

    const carousel = button.closest('[data-look-carousel]');
    const track = carousel && carousel.querySelector('[data-look-track]');
    if (!track) return;

    const direction = Number(button.dataset.lookScroll);
    track.scrollBy({
      left: direction * track.clientWidth * 0.82,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
